import type { Theme } from "@mui/material/styles";

export const breadcrumbStyles = (theme: Theme) => ({
  breadcrumbChildLinkText: {
    fontSize: "0.875rem",
    fontWeight: 300,
    color: theme.palette.text.secondary,
    display: "inline",
  },
});
